import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {AlertService} from "../services";
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';
import {finalize, first} from 'rxjs/operators';
import {MatDialog} from "@angular/material/dialog";

import { locale as polish } from './i18n/pl';
import {ComponentTitleService} from "../services/componentTitle.service";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {InternalFileService} from "./service/internalFile.service";
import {File} from "../models/file";
import {HttpEventType} from "@angular/common/http";
import {Gallery} from "../cms/gallery/model/gallery";
import {Subscription} from "rxjs";

@Component({
    templateUrl: './internalFileForm.component.html',
    styleUrls: ['./internalFileForm.component.scss']
})

export class InternalFileFormComponent implements OnInit {

    form: FormGroup;
    loading = false;
    submitted = false;
    id: string;
    isAddMode: boolean;
    categories: any[];
    units: any[];
    file: File;
    files: any[] = [];
    @ViewChild("fileDropRef", { static: false }) fileDropEl: ElementRef;
    uploadSub: Subscription;

    constructor(
        public _matDialog: MatDialog,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private internalFileService: InternalFileService,
    ) {
        this.translationLoader.loadTranslations(polish);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Files');
    }

    ngOnInit() {
        this.id = this.route.snapshot.params['id'];
        this.isAddMode = !this.id;

        if (this.isAddMode) {
            this.componentTitleService.addPart('New');
        } else {
            this.componentTitleService.addPart('Edit');
            this.file = this.route.snapshot.data.file;
        }

        this.form = this.formBuilder.group({
            name: ['', Validators.required],
            tag: ['', Validators.required],
            gdprDocument: [false],
            applicationRegulationsDocument: [false],
        });

        if (!this.isAddMode) {
            this.f.name.setValue(this.file.name);
            this.f.tag.setValue(this.file.name);
            this.f.gdprDocument.setValue(this.file.gdprDocument);
            this.f.applicationRegulationsDocument.setValue(this.file.applicationRegulationsDocument);
        }
    }

    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        this.alertService.clear();

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;

        if (this.isAddMode) {
            this.createFile();
        } else {
            this.updateFile();
        }
    }

    onFileDropped($event) {
        this.files = [];
        this.prepareFilesList($event);
    }

    fileBrowseHandler(files) {
        this.files = [];
        this.prepareFilesList(files);
    }

    prepareFilesList(files: Array<any>) {
        for (const item of files) {
            item.progress = 0;
            this.files.push(item);
        }
        this.fileDropEl.nativeElement.value = "";
    }

    uploadFilesSimulator(index: number) {
        if (index === this.files.length) {
            return;
        } else {
            const formData = new FormData();
            formData.append("file", this.files[index]);
            formData.append("name", this.form.value.name);
            formData.append("tag", this.form.value.tag);
            formData.append("gdprDocument", this.form.value.gdprDocument);
            formData.append("applicationRegulationsDocument", this.form.value.applicationRegulationsDocument);

            const upload$ = this.internalFileService.uploadFile(formData).pipe(
                finalize(() => {this.reset(); this.deleteFile(index);})
            );

            this.uploadSub = upload$.subscribe(event => {
                if (event.type == HttpEventType.UploadProgress) {
                    this.files[index].progress = Math.round(100 * (event.loaded / event.total));
                }
            })
        }
    }

    deleteFile(index: number) {
        if (this.files[index].progress < 100) {
            console.log("Upload in progress.");
            return;
        }
        this.files.splice(index, 1);
    }

    reset() {
        this.uploadSub = null;
        this.files = [];
    }

    cancelUpload() {
        this.uploadSub.unsubscribe();
        this.reset();
    }

    formatBytes(bytes, decimals = 2) {
        if (bytes === 0) {
            return "0 Bytes";
        }
        const k = 1024;
        const dm = decimals <= 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }

    private createFile() {
        this.uploadFilesSimulator(0)
        // this.alertService.success('File added successfully', { keepAfterRouteChange: true });
        this.router.navigate(['/files']);
    }

    private updateFile() {

    }
}
